module.exports = __webpack_public_path__ + "static/media/no-found-conversation.9a0efc8f.svg";